import { createSlice } from "@reduxjs/toolkit";

import { ThunkGetValidationConfig } from "./thunks";
import { IPsaContactValidationState } from "./types";
import initConfiguration from "../../constants/initialConfiguration";

const initialState: IPsaContactValidationState = {
  isInitialized: false,
  config: initConfiguration,
};

export const psaContactValidationSlice = createSlice({
  name: "psaContactValidationSlice",
  initialState,
  reducers: {
    setInitialized: state => {
      state.isInitialized = true;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      ThunkGetValidationConfig.fulfilled,
      (state, { payload }) => {
        state.config = payload;
      }
    );
  },
});

export const { setInitialized } = psaContactValidationSlice.actions;
export default psaContactValidationSlice.reducer;
